<template>
    <div class="row">
        <div class="col-12 mt-4 mb-2">
            <span><b>*Puedes seleccionar el tipo de abono seguido de los precios que quieras del mismo. Las butacas de los abonados que tengan ese tipo de abono y precio, NO SE CERRARÁN.</b></span>
        </div>
        <div class="col-12 mb-2">
            <span><b>*Este apartado solo se podrá modificar si el evento NO ESTÁ PUBLICADO</b></span>
        </div>
        <div :class="!descuentos_edad?.length ? 'col-12' : (localData.descuentos_abonados_no_cerrar_butacas_seleccionados?.length ? 'col-md-5' : 'col-md-6')">
            <div class="form-group">
                <label for="tipo de abono">Tipo de abono que no se le cerrarán las butacas</label>
                <multiselect
                    v-model="localData.tipo_abono_no_cerrar_butacas"
                    placeholder="Tipo de abono que no se le cerrarán las butacas"
                    label="descripcion"
                    track-by="id"
                    name="tipo de abono"
                    :options="tipos"
                    :disabled="localData.status?.id === 1"
                    style="z-index: 999;"
                />
            </div>
        </div>
        <div v-if="descuentos_edad?.length" :class="localData.descuentos_abonados_no_cerrar_butacas_seleccionados?.length ? 'col-md-5' : 'col-md-6'">
            <div class="form-group">
                <label for="precios">Precios que no se les cerrarán las butacas</label>
                <multiselect
                    v-model="localData.descuentos_abonados_no_cerrar_butacas_seleccionados"
                    placeholder="Precios que no se les cerrarán las butacas"
                    label="descripcion"
                    track-by="id"
                    name="precios"
                    :multiple="true"
                    :options="descuentos_edad"
                    :disabled="localData.status?.id === 1"
                    style="z-index: 999;"
                />
            </div>
        </div>
        <div v-if="localData.tipo_abono_no_cerrar_butacas && localData.descuentos_abonados_no_cerrar_butacas_seleccionados?.length" class="col-12 col-md-2 mt-0 mt-md-4">
            <b-button class="w-100" @click="addDescuentos()" :disabled="localData.status?.id === 1">Añadir</b-button>
        </div>
        <div class="col-12" v-if="this.localData.no_cerrar_butacas_combinaciones?.length">
            <hr class="mb-4 mt-2" />
            <table class="table table-sm table-hover table-borderless align-middle mb-0">
                <thead class="thead-light">
                    <tr>
                        <th>Tipo de abono</th>
                        <th>Descuentos asociados</th>
                        <th class="text-center" style="width: 60px;">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item) in this.localData.no_cerrar_butacas_combinaciones" :key="item.tipo.id">
                        <td class="font-weight-semibold">{{ item.tipo.descripcion }}</td>
                        <td>
                            <div class="d-flex flex-wrap align-items-center">
                                <span
                                    v-for="desc in item.descuentos"
                                    :key="desc.id"
                                    class="badge badge-light border text-muted mr-1 mb-1 d-flex align-items-center"
                                >
                                    <span>{{ desc.descripcion }}</span>
                                    <i
                                        class="fas fa-times text-danger ml-2"
                                        title="Eliminar descuento"
                                        role="button"
                                        :class="{ 'disabled': localData.status?.id === 1, 'text-muted': localData.status?.id === 1 }"
                                        :style="{ cursor: localData.status?.id === 1 ? 'not-allowed' : 'pointer' }"
                                        @click="localData.status?.id !== 1 && eliminar(item.tipo.id, desc.id)"
                                    ></i>
                                </span>
                            </div>
                        </td>
                        <td class="text-center">
                            <span 
                                v-b-tooltip.hover.html="{
                                    title: 'Esto eliminará el tipo de abono y los precios del mismo de la tabla',
                                }"
                                class="text-muted"
                            >
                                <i
                                    class="fas fa-trash text-danger"
                                    role="button"
                                    title="Eliminar tipo completo y todos sus descuentos"
                                    :class="{ 'disabled': localData.status?.id === 1, 'text-muted': localData.status?.id === 1 }"
                                    :style="{ cursor: localData.status?.id === 1 ? 'not-allowed' : 'pointer' }"
                                    @click="localData.status?.id !== 1 && eliminar(item.tipo.id)"
                                ></i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            evento: {
                type: Object,
                required: true
            },
            tipos: {
                type: Array
            }
        },
        data() {
            return {
                localData: { ...this.evento },
                descuentos_edad: []
            }
        },
        methods: {
            getDescuentos(precio) {
                this.loading = true;

                const params = {
                    filters :  {
                        to_select: true
                    },
                    lista_id: this.$store.getters.getListaId,
                    precio_id: precio.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.descuentos'), params).then(res => {
                    this.descuentos_edad = res.data.data;
                    this.loading = false;
                });
            },
            addDescuentos() {
                const tipo = this.localData.tipo_abono_no_cerrar_butacas;
                const descuentos = this.localData.descuentos_abonados_no_cerrar_butacas_seleccionados || [];

                if (!tipo || !descuentos.length) return;

                const existente = this.localData.no_cerrar_butacas_combinaciones.find(c => c.tipo.id === tipo.id);

                if (existente) {
                    descuentos.forEach(desc => {
                        if (!existente.descuentos.some(d => d.id === desc.id)) {
                            existente.descuentos.push(desc);
                        }
                    });
                } else {
                    this.localData.no_cerrar_butacas_combinaciones.push({
                        tipo,
                        descuentos: [...descuentos]
                    });
                }

                this.descuentos_edad = [];
                this.localData.tipo_abono_no_cerrar_butacas = null;
                this.localData.descuentos_abonados_no_cerrar_butacas_seleccionados = [];
                this.updateEvento();
            },
            eliminar(tipoId, descuentoId = null) {
                this.localData.no_cerrar_butacas_combinaciones = this.localData.no_cerrar_butacas_combinaciones
                    .map(c => {
                        if (c.tipo.id !== tipoId) return c;
                        return descuentoId
                            ? { ...c, descuentos: c.descuentos.filter(d => d.id !== descuentoId) }
                            : null;
                    })
                    .filter(c => c && c.descuentos.length > 0);

                if (this.localData.tipo_abono_no_cerrar_butacas?.id === tipoId) {
                    const tipo = this.localData.no_cerrar_butacas_combinaciones.find(c => c.tipo.id === tipoId);
                    this.localData.descuentos_abonados_no_cerrar_butacas_seleccionados = tipo?.descuentos || [];
                }

                this.updateEvento();
            },
            updateEvento() {
                this.$emit('updateEvento', this.localData);
            }
        },
        watch: {
            'evento': {
                handler(newData) {
                    this.localData = { ...newData };
                },
                deep: true
            },
            'localData.tipo_abono_no_cerrar_butacas'(newVal) {
                if (newVal) this.getDescuentos(newVal);
                const existente = this.localData.no_cerrar_butacas_combinaciones?.find(c => c.tipo?.id === newVal?.id);
                this.localData.descuentos_abonados_no_cerrar_butacas_seleccionados = existente ? [...existente.descuentos] : [];
            },
            'localData.descuentos_abonados_no_cerrar_butacas_seleccionados': {
                handler(newDescuentos) {
                    const tipo = this.localData.tipo_abono_no_cerrar_butacas;
                    if (!tipo) return;

                    const combinacion = this.localData.no_cerrar_butacas_combinaciones.find(c => c.tipo.id === tipo.id);
                    if (!combinacion) return;

                    if (!newDescuentos.length) {
                        this.eliminar(tipo.id);
                        return;
                    }

                    const eliminados = combinacion.descuentos.filter(d => !newDescuentos.some(nd => nd.id === d.id));
                    eliminados.forEach(d => this.eliminar(tipo.id, d.id));
                },
                deep: true
            }
        },
        created() {
            if (this.localData.descuentos_abonados_no_cerrar_butacas?.length) {
                const map = new Map();

                this.localData.descuentos_abonados_no_cerrar_butacas.forEach(d => {
                    if (!map.has(d.tipo_abono.id)) {
                        map.set(d.tipo_abono.id, { tipo: d.tipo_abono, descuentos: [] });
                    }
                    map.get(d.tipo_abono.id).descuentos.push(
                        (({ id, descripcion, precio }) => ({ id, descripcion, precio }))(d)
                    );
                });

                this.localData.no_cerrar_butacas_combinaciones = [...map.values()];
            } else {
                this.localData.no_cerrar_butacas_combinaciones = [];
            }

            this.updateEvento();
        }
    }
</script>